export default __webpack_public_path__ + "static/media/felo.d8ec68f5.mp3";